import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import type { FC, HTMLProps } from 'react'

interface StepProps extends HTMLProps<HTMLDivElement> {
  classNameSubContainer?: string
  variant: 'regular' | 'large'
  step: string
}
interface CompetencyStepperProps {
  variant?: 'regular' | 'large'
  step: number
  animated?: boolean
}

const steps = {
  1: 'bg-[#6BBDF7]',
  2: 'bg-[#57A1EB]',
  3: 'bg-[#3D7FDC]',
  4: 'bg-[#2762CF]',
  5: 'bg-[#0E43C1]',
}

const stepSeparators = {
  1: 'from-[#6BBDF7] to-[#57A1EB]',
  2: 'from-[#57A1EB] to-[#3D7FDC]',
  3: 'from-[#3D7FDC] to-[#2762CF]',
  4: 'from-[#2762CF] to-[#0E43C1]',
}

const Step: FC<StepProps> = ({ step, classNameSubContainer, variant }) => {
  return (
    <div className="flex flex-row items-center">
      <div
        className={clsx(
          'flex items-center justify-center rounded-full z-10',
          variant == 'large' ? 'h-6 w-6' : 'h-5 w-5',
          classNameSubContainer
        )}
      >
        <Text color="inverse" variant="helper-bold">
          {step}
        </Text>
      </div>
    </div>
  )
}

const CompetencyStepper: FC<CompetencyStepperProps> = ({
  step,
  variant = 'regular',
  animated = false,
}) => (
  <div className="relative">
    <style jsx global>
      {`
        @-webkit-keyframes fading {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
        @keyframes fading {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        @-webkit-keyframes pulse {
          0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(14, 67, 193, 0.7);
          }

          70% {
            transform: scale(1);
            box-shadow: 0 0 0 10px rgba(14, 67, 193, 0);
          }

          100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(14, 67, 193, 0);
          }
        }

        @keyframes pulse {
          0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(14, 67, 193, 0.7);
          }

          70% {
            transform: scale(1);
            box-shadow: 0 0 0 10px rgba(14, 67, 193, 0);
          }

          100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(14, 67, 193, 0);
          }
        }

        .pulsing {
          box-shadow: 0 0 0 0 rgba(14, 67, 193, 1);
          transform: scale(1);
          animation: pulse 2s infinite;
        }

        .fading {
          -webkit-animation: fading 0.6s ease-in;
          -webkit-animation-fill-mode: forwards;
          animation: fading 0.6s ease-in;
          animation-fill-mode: forwards;
        }
      `}
    </style>
    <div className="flex flex-row items-center relative">
      {Object.entries(steps).map((thisStep, index) => (
        <React.Fragment key={`step_${index}`}>
          {index > 0 && (
            <span
              className={clsx(
                'mx-[-1px] h-1.5 bg-gradient-to-r bg-[#D9D9D9]',
                animated ? 'fading w-[20%]' : 'w-[20%]',
                step > index && stepSeparators[index]
              )}
            />
          )}
          <Step
            step={thisStep[0]}
            variant={variant}
            classNameSubContainer={
              step > index
                ? `${thisStep[1]} ${animated && 'pulsing'}`
                : 'bg-[#D9D9D9]'
            }
          />
        </React.Fragment>
      ))}
    </div>
  </div>
)

export default CompetencyStepper
